<p-dialog header="Suspender campanha"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '35rem' }"
  (onHide)="handleClose()">

    <form class="p-fluid grid" [formGroup]="form">
        <div class="field col-12 flex flex-column gap-2">
            <p>Motivo</p>
            <p-select [options]="motivos" optionLabel="label" optionValue="id" formControlName="motivo" appendTo="body" (invalid)="isInvalid('motivo')"></p-select>
            <small class="error" *ngIf="isInvalid('motivo')">Motivo é obrigatório.</small>
        </div>
        <div class="field col-12 flex flex-column gap-2" *ngIf="form.get('motivo')?.value === 17">
            <p>Descreva o seu motivo</p>
            <textarea rows="5" cols="30" pTextarea formControlName="descricao" class="no-resize" (invalid)="isInvalid('descricao')"></textarea>
            <small class="error" *ngIf="isInvalid('descricao')">Descrição é obrigatório.</small>
        </div>
    </form>

    <div class="flex justify-content-between gap-2">
        <p-button label="Cancelar" severity="secondary" (click)="cancel()" />
        <p-button severity="success" (click)="suspenderCampanha()">
            {{ loading ? 'Suspendendo' : 'Suspender'}}
            <i class="pi pi-spin pi-spinner" *ngIf="loading"></i>
        </p-button>
    </div>
</p-dialog>